import baseConfig from './base'

const config = {
  appEnv: 'dist',
  historyConfig: {
    basename: '/'
  },
  apiMock: true,
  apiBaseUrl: 'http://localhost:3000/api/internal/v1'
}

export default Object.freeze(Object.assign({}, baseConfig, config))


// WEBPACK FOOTER //
// ./src/config/production.js